import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { ApiModule } from '../generated_client/api.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LiquidacionesParticularOrdersComponent } from './components/adm-management/liquidaciones/liquidaciones-particular-orders/liquidaciones-particular-orders.component';
import { MatMenuModule } from '@angular/material/menu';
import { LayoutModule } from '@angular/cdk/layout';
import { QuillModule } from 'ngx-quill';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ChartsModule } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from '@hardpool/ngx-spinner';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { WithoutNavBarComponent } from './navbar-config/without-nav-bar/without-nav-bar.component';
import { WithNavBarComponent } from './navbar-config/with-nav-bar/with-nav-bar.component';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/adm-management/home-page/home/home.component';
import { CityManagementComponent } from './components/adm-management/city/city-management/city-management.component';
import { AddCityComponent } from './components/adm-management/city/add-city/add-city.component';
import { AdmComercioComponent } from './components/adm-management/shop/adm-comercio/adm-comercio.component';

import { EditarAdminComponent } from './components/adm-management/admin/editar-admin/editar-admin.component';
import { AddShopComponent } from './components/adm-management/shop/add-shop/add-shop.component';
import { DiscountManagementComponent } from './components/adm-management/discount/discount-management/discount-management.component';
import { RecentOrdersComponent } from './components/adm-management/home-page/recent-orders/recent-orders.component'
import { StatusPipe } from './pipes/status.pipe';
import { ChangeStatusPipe } from './pipes/change-status.pipe';
import { EstadoComercioPipe } from './pipes/estado-comercio.pipe';
import { CambioEstadoComercioPipe } from './pipes/cambio-estado-comercio.pipe';
import { ShopTypeManagementComponent } from './components/adm-management/shopType/shop-type-management/shop-type-management.component';
import { AddShopTypeComponent } from './components/adm-management/shopType/add-shop-type/add-shop-type.component';
import { AddDiscountComponent } from './components/adm-management/discount/add-discount/add-discount.component';
import { PassManagementComponent } from './components/adm-management/admin/pass-management/pass-management.component';
import { PersonalComponent } from './components/adm-management/personalMembers/personal/personal.component';
import { AddPersonComponent } from './components/adm-management/personalMembers/add-person/add-person.component';
import { EditPersonComponent } from './components/adm-management/personalMembers/edit-person/edit-person.component';
import { ChangePersonStatusPipe } from './pipes/change-person-status.pipe';
import { AppPagesComponent } from './components/adm-management/app-pages/app-pages.component';
import { BannersManagementComponent } from './components/adm-management/banners/banners-management/banners-management.component';
import { AddBannerComponent } from './components/adm-management/banners/add-banner/add-banner.component';
import { AppUsersComponent } from './components/adm-management/app-users/app-users.component';
import { LiquidacionesCadetesComponent } from './components/adm-management/liquidaciones/liquidaciones-cadetes/liquidaciones-cadetes.component';
import { LiquidacionesClientesComponent } from './components/adm-management/liquidaciones/liquidaciones-clientes/liquidaciones-clientes.component';
import { LiquidacionesEmpresasComponent } from './components/adm-management/liquidaciones/liquidaciones-empresas/liquidaciones-empresas.component';
import { RecibosCadetesComponent } from './components/adm-management/liquidaciones/recibos-cadetes/recibos-cadetes.component';
import { SalesReportComponent } from './components/adm-management/reports/sales-report/sales-report.component';
import { DeliveryReportComponent } from './components/adm-management/reports/delivery-report/delivery-report.component';
import { StartSliderComponent } from './components/adm-management/sliders/start-slider/start-slider.component';
import { EditSliderComponent } from './components/adm-management/sliders/edit-slider/edit-slider.component';
import { AddSliderComponent } from './components/adm-management/sliders/add-slider/add-slider.component';
import { NotificationsComponent } from './components/adm-management/notifications/notifications.component';
import { ConsultaLiquidacionesComponent } from './components/adm-management/reports/consulta-liquidaciones/consulta-liquidaciones.component';
import { ConsultaRecibosCadetesComponent } from './components/adm-management/reports/consulta-recibos-cadetes/consulta-recibos-cadetes.component';
import { UserManagementComponent } from './components/shop-management/user-management/user-management.component';
import { AdditionalsComponent } from './components/shop-management/extras/additionals/additionals.component';
import { EditExtraComponent } from './components/shop-management/extras/edit-extra/edit-extra.component';
import { AddExtraComponent } from './components/shop-management/extras/add-extra/add-extra.component';
import { OptionalsManagementComponent } from './components/shop-management/optionals/optionals-management/optionals-management.component';
import { AddOptionalComponent } from './components/shop-management/optionals/add-optional/add-optional.component';

import { CategoriesManagementComponent } from './components/shop-management/categories/categories-management/categories-management.component';
import { AddCategoryComponent } from './components/shop-management/categories/add-category/add-category.component';
import { ActiveOrdersComponent } from './components/adm-management/orders/active-orders/active-orders.component';
import { CancelledOrdersComponent } from './components/adm-management/orders/cancelled-orders/cancelled-orders.component';
import { ChangeAorderStatusPipe } from './pipes/change-aorder-status.pipe';
import { ChangeOrderOptionPipe } from './pipes/change-order-option.pipe';
import { AssignedOrdersComponent } from './components/adm-management/orders/assigned-orders/assigned-orders.component';
import { DialogAssignComponent } from './components/adm-management/orders/dialog-assign/dialog-assign.component';
import { CompletedOrdersComponent } from './components/adm-management/orders/completed-orders/completed-orders.component';
import { OrderDetailComponent } from './components/adm-management/orders/order-detail/order-detail.component';
import { OrderReceiptComponent } from './components/adm-management/orders/order-receipt/order-receipt.component';
import { LoginShopComponent } from './components/shop-management/login-shop/login-shop.component';
import { LoginAdminComponent } from './components/adm-management/login-admin/login-admin.component';
import { ActiveShopOrdersComponent } from './components/shop-management/shop-orders/active-shop-orders/active-shop-orders.component';
import { ShopOrderDetailComponent } from './components/shop-management/shop-orders/shop-order-detail/shop-order-detail.component';
import { CancelledShopOrdersComponent } from './components/shop-management/shop-orders/cancelled-shop-orders/cancelled-shop-orders.component';
import { RejectedWithCardShopOrdersComponent } from './components/shop-management/shop-orders/rejected-with-card-shop-orders/rejected-with-card-shop-orders.component';
import { CompletedShopOrdersComponent } from './components/shop-management/shop-orders/completed-shop-orders/completed-shop-orders.component';
import { EditActiveOrderComponent } from './components/shop-management/shop-orders/edit-active-order/edit-active-order.component';
import { LiquidationsComponent } from './components/shop-management/liquidations/liquidations.component';
import { ShopSalesReportComponent } from './components/shop-management/shop-sales-report/shop-sales-report.component';
import { ProductManagementComponent } from './components/shop-management/products/product-management/product-management.component';
import { EditProductComponent } from './components/shop-management/products/edit-product/edit-product.component';
import { AddProductComponent } from './components/shop-management/products/add-product/add-product.component';
import { OptionalsComponent } from './components/shop-management/products/optionals/optionals.component';
import { ShopHomeComponent } from './components/shop-management/shop-home/shop-home.component';
import { ShopPasswordComponent } from './components/shop-management/shop-password/shop-password.component';
import { BASE_PATH } from 'src/generated_client';
import { environment } from 'src/environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NavComponent } from './shared/nav-admin/nav.component';
import { NavStoreComponent } from './shared/nav-store/nav-store.component';
import { TokenInterceptor } from './services/auth/token.interceptor';
import { RouterModule } from '@angular/router';
import localeEsAr from '@angular/common/locales/es-AR';
import { DatePipe, registerLocaleData } from '@angular/common';
import { GetBannerCityPipe } from './pipes/get-banner-city.pipe';
import { GetBannerPositionPipe } from './pipes/get-banner-position.pipe';
import { OpenCloseStorePipe } from './pipes/open-close-store.pipe';
import { WithShopNavBarComponent } from './navbar-config/with-shop-nav-bar/with-shop-nav-bar.component';
import { LoadingComponent } from './components/loading/loading.component';
import { LoadingService } from './services/loading.service';
import { LoadingInterceptor } from './services/loading.interceptor';
import { OrdersStatusPipe } from './pipes/orders-status.pipe';
import { ParticularOrderStatusPipe } from './pipes/particular-order-status.pipe';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { CadetSearchDialogComponent } from './components/adm-management/shipments/cadet-search-dialog/cadet-search-dialog.component';
import { PaymentMethodPipe } from './pipes/payment-method.pipe';
import { GetTimeDialogComponent } from './components/shop-management/shop-orders/get-time-dialog/get-time-dialog.component';
import { DiscountsManagementComponent } from './components/shop-management/discount-management/discounts-management/discounts-management.component';
import { AddStoreDiscountComponent } from './components/shop-management/discount-management/add-store-discount/add-store-discount.component';
import { ConfirmDialog } from './components/shop-management/products/confirm-dialog/confirm-dialog';
import { DeliveryPipe } from './pipes/delivery.pipe'
import { RejectionMessagesComponent } from './components/shop-management/shop-orders/rejection-messages/rejection-messages.component';
import { AddressFormComponent } from './components/adm-management/shipments/address-form/address-form.component';
import { CostTableComponent } from './components/adm-management/shipments/cost-table/cost-table.component';
import { ParticularOrdersListComponent } from './components/adm-management/shipments/particular-orders-list/particular-orders-list.component';
import { ViewOrderComponent } from './components/adm-management/shipments/view-order/view-order.component';
import { PricingRulesComponent } from './components/adm-management/shipments/pricing-rules/pricing-rules.component';
import { DeliveryRecordsComponent } from './components/adm-management/delivery/delivery-records/delivery-records.component';
import { EditShiftSessionComponent } from './components/adm-management/delivery/edit-shift-session/edit-shift-session.component';
import { FixedPointPricingRulesComponent } from './components/adm-management/delivery/fixed-point-pricing-rules/fixed-point-pricing-rules.component';
import { LiquidacionesWorkShiftSessionsComponent } from './components/adm-management/liquidaciones/liquidaciones-work-shift-sessions/liquidaciones-work-shift-sessions.component';
import { SelectPricingRuleDialogComponent } from './components/adm-management/liquidaciones/liquidaciones-work-shift-sessions/select-pricing-rule-dialog/select-pricing-rule-dialog.component';
import { ArgentinaDateTimePipe } from './pipes/argentina-date-time.pipe';
import { ArgentinaDateOnlyPipe } from './pipes/argentina-date-only.pipe';
import { ClientListComponent } from './components/adm-management/clients/client-list/client-list.component';
import { NumericOnlyDirective } from './directives/numeric-only.directive';

registerLocaleData(localeEsAr, 'es-Ar')

@NgModule({
  declarations: [
    AppComponent,
    AddressFormComponent,
    CostTableComponent,
    HomeComponent,
    CityManagementComponent,
    StatusPipe,
    ChangeStatusPipe,
    AddCityComponent,
    AdmComercioComponent,
    LoginAdminComponent,
    EstadoComercioPipe,
    CambioEstadoComercioPipe,
    AddShopComponent,
    DiscountManagementComponent,
    AddShopTypeComponent,
    ShopTypeManagementComponent,
    CambioEstadoComercioPipe,
    AddShopComponent,
    EditarAdminComponent,
    AddDiscountComponent,
    PassManagementComponent,
    PersonalComponent,
    AddPersonComponent,
    EditPersonComponent,
    ChangePersonStatusPipe,
    AppPagesComponent,
    BannersManagementComponent,
    AddBannerComponent,
    AppUsersComponent,
    LiquidacionesCadetesComponent,
    LiquidacionesEmpresasComponent,
    RecibosCadetesComponent,
    SalesReportComponent,
    DeliveryReportComponent,
    StartSliderComponent,
    EditSliderComponent,
    AddSliderComponent,
    RecentOrdersComponent,
    RecibosCadetesComponent,
    ConsultaLiquidacionesComponent,
    ConsultaRecibosCadetesComponent,
    ActiveOrdersComponent,
    CancelledOrdersComponent,
    ChangeAorderStatusPipe,
    ChangeOrderOptionPipe,
    DialogAssignComponent,
    AssignedOrdersComponent,
    CompletedOrdersComponent,
    OrderDetailComponent,
    OrderReceiptComponent,
    UserManagementComponent,
    AdditionalsComponent,
    EditExtraComponent,
    AddExtraComponent,
    NotificationsComponent,
    OptionalsManagementComponent,
    AddOptionalComponent,
    CategoriesManagementComponent,
    ActiveShopOrdersComponent,
    ShopOrderDetailComponent,
    CancelledShopOrdersComponent,
    CompletedShopOrdersComponent,
    PricingRulesComponent,
    EditActiveOrderComponent,
    LiquidationsComponent,
    ShopSalesReportComponent,
    AddCategoryComponent,
    LoginShopComponent,
    EditProductComponent,
    AddProductComponent,
    OptionalsComponent,
    ShopHomeComponent,
    ShopPasswordComponent,
    ProductManagementComponent,
    NavComponent,
    GetBannerCityPipe,
    GetBannerPositionPipe,
    WithoutNavBarComponent,
    WithNavBarComponent,
    NavStoreComponent,
    WithShopNavBarComponent,
    LoadingComponent,
    OpenCloseStorePipe,
    OrdersStatusPipe,
    ParticularOrderStatusPipe,
    ConfirmDialogComponent,
    CadetSearchDialogComponent,
    PaymentMethodPipe,
    GetTimeDialogComponent,
    RejectedWithCardShopOrdersComponent,
    DiscountsManagementComponent,
    AddStoreDiscountComponent,
    ConfirmDialog,
    DeliveryPipe,
    RejectionMessagesComponent,
    ParticularOrdersListComponent,
    ViewOrderComponent,
    CadetSearchDialogComponent,
    LiquidacionesParticularOrdersComponent,
    PricingRulesComponent,
    DeliveryRecordsComponent,
    EditShiftSessionComponent,
    FixedPointPricingRulesComponent,
    LiquidacionesWorkShiftSessionsComponent,
    SelectPricingRuleDialogComponent,
    ArgentinaDateTimePipe,
    ArgentinaDateOnlyPipe,
    ClientListComponent,
    LiquidacionesClientesComponent,
    NumericOnlyDirective
  ],
  entryComponents: [
    ConfirmDialogComponent,
    GetTimeDialogComponent,
    ConfirmDialog,
    CadetSearchDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    ApiModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    LayoutModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatTableModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    HttpClientModule,
    GooglePlaceModule,
    QuillModule.forRoot({
      customOptions: [{
        import: 'formats/font',
        whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
      }]
    }),
    MatTableExporterModule,
    ChartsModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    RouterModule
  ],
  providers: [
    LoadingService,
    { provide: BASE_PATH, useValue: environment.apiBaseUrl },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-Ar' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: '$' },
    DatePipe,
    OrdersStatusPipe,
    ParticularOrderStatusPipe
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
